/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";
import "./style.css";

export const EyesDefault = ({
  className,
  eyeClassName,
  eyeClassNameOverride,
}) => {
  return (
    <div className={`eyes-default ${className}`}>
      <div className={`eye ${eyeClassName}`} />

      <div className={`eye-2 ${eyeClassNameOverride}`} />
    </div>
  );
};
